export const calcZoomLevel = (
  startDate: Date,
  endDate: Date,
  zoomMin: number,
  zoomMax: number,
  round = true
) => {
  const windowDuration = endDate.getTime() - startDate.getTime();
  const zoomLevel =
    1 - Math.log(windowDuration / zoomMin) / Math.log(zoomMax / zoomMin);
  return round ? Number(zoomLevel.toFixed(1)) : zoomLevel;
};
